import ApiInstance from "./ApiInstance";

export type ReportEntityType = "psychologist_profile" | "course" | "other";

export interface ReportPayload {
  entityType: ReportEntityType;
  entityRef?: string;
  description: string;
  reporterEmail?: string;
  /** Honeypot — must stay empty; hidden field in the form. */
  website?: string;
}

class ReportApi {
  /** DSA art. 16 "Probleem melden": returns the reference number of the report. */
  async create(payload: ReportPayload): Promise<{ ok: boolean; reference: string }> {
    const { data } = await ApiInstance.getApi().post("/report", payload);
    return data;
  }
}

const reportApi = new ReportApi();
export default reportApi;
